import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "./errorMessage";
import Validator, { ValidatedValue, ValidatorModel } from "./validator";

export interface GravestoneProposalModel {
  cemeteryName: ValidatedValue<string>;
  cemeteryAddress: ValidatedValue<string>;
  year: ValidatedValue<number>;
  sector: ValidatedValue<string>;
  row: ValidatedValue<string>;
  plot: string;

  reset: () => void;
  validate: () => void;
}

interface DefaultGravestoneArguments {
  cemeteryName?: string;
  cemeteryAddress?: string;
  year?: number;
  sector?: string;
  row?: string;
  plot?: string;
}
export const MAX_GRAVESTONE_AGE = 25;

const gravestoneValidators: ValidatorModel = {
  cemeteryName: [
    { name: "cemeteryNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "cemeteryNameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ],
  cemeteryAddress: [
    { name: "cemeteryAddressIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "cemeteryAddressIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ],
  year: [
    { name: "yearIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "yearIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
    { name: "yearEarlierThanCurrent", fn: Validator.yearEarlierThanCurrent, errorMessage: ErrorMessages.year.earlierThanCurrent },
    { name: "yearMin", fn: Validator.min(new Date().getFullYear() - MAX_GRAVESTONE_AGE), errorMessage: "Podany rok nie może być wcześniejszy niż " + (new Date().getFullYear() - MAX_GRAVESTONE_AGE) }
  ],
  sector: [
    { name: "sectorIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "sectorIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ],
  row: [
    { name: "rowIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "rowIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
    { name: "rowIsCorrectValidation", fn: Validator.isValidRowGravestone, errorMessage: ErrorMessages.invalid }
  ]
};

export class GravestoneProposal implements GravestoneProposalModel {

  @observable cemeteryName: ValidatedValue<string> = new ValidatedValue("", gravestoneValidators.cemeteryName);
  @observable cemeteryAddress: ValidatedValue<string> = new ValidatedValue("", gravestoneValidators.cemeteryAddress);
  @observable year: ValidatedValue<number> = new ValidatedValue(0, gravestoneValidators.year);
  @observable sector: ValidatedValue<string> = new ValidatedValue("", gravestoneValidators.sector);
  @observable row: ValidatedValue<string> = new ValidatedValue("", gravestoneValidators.row);
  @observable plot: string;


  constructor(args?: DefaultGravestoneArguments) {
    makeObservable(this);

    this.cemeteryName.value = args?.cemeteryName ?? "";
    this.cemeteryAddress.value = args?.cemeteryAddress ?? "";
    this.year.value = args?.year ?? 0;
    this.sector.value = args?.sector ?? "";
    this.row.value = args?.row ?? "";
    this.plot = args?.plot ?? "";
  }

  @action
  public reset() {
    this.cemeteryName.clearValidation();
    this.cemeteryAddress.clearValidation();
    this.year.clearValidation();
    this.sector.clearValidation();
    this.row.clearValidation();
  }


  @action
  public validate() {
    this.cemeteryName.validate();
    this.cemeteryAddress.validate();
    this.year.validate();
    this.sector.validate();
    this.row.validate();
  }
}
